module.exports = __webpack_public_path__ + "static/media/me-5.2e47479f.svg";